import { render, staticRenderFns } from "./TaskMetricsChart.vue?vue&type=template&id=f712fc70&scoped=true"
import script from "./TaskMetricsChart.vue?vue&type=script&lang=js"
export * from "./TaskMetricsChart.vue?vue&type=script&lang=js"
import style0 from "./TaskMetricsChart.vue?vue&type=style&index=0&id=f712fc70&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "f712fc70",
  null
  
)

export default component.exports